import React, { useState } from 'react';
import { AppTableCard, AppTableEmptyState, AppTablePagination } from '../../../../../Components/TableKit';

const ROWS_PER_PAGE = 5;

const BuroTableTK = ({ data = [], columns = [], name = '' }) => {
    const [page, setPage] = useState(1);

    const total = data.length;
    const lastPage = Math.max(1, Math.ceil(total / ROWS_PER_PAGE));
    const start = (page - 1) * ROWS_PER_PAGE;
    const pageData = data.slice(start, start + ROWS_PER_PAGE);

    const getFieldValue = (row, field) => {
        if (!field || !field.trim()) return '-';
        const key = field.trim();
        const val = row[key];
        if (val === null || val === undefined || String(val).trim() === '') return '-';
        return String(val);
    };

    const pagination = total > ROWS_PER_PAGE ? (
        <AppTablePagination
            page={page}
            lastPage={lastPage}
            total={total}
            perPage={ROWS_PER_PAGE}
            onPageChange={setPage}
        />
    ) : null;

    return (
        <div className="flex flex-column gap-1">
            {name && (
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-table text-sm" style={{ color: '#1565C0' }} />
                    <span className="text-sm font-bold text-700" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {name}
                    </span>
                </div>
            )}
            <AppTableCard animated={false} footer={pagination}>
                <table className="tk-table tk-table--compact tk-table--striped">
                    <thead>
                        <tr>
                            {columns.map((col, i) => (
                                <th key={i}>{col.header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.length === 0 ? (
                            <AppTableEmptyState
                                colSpan={columns.length || 1}
                                icon="pi pi-inbox"
                                message="No hay datos disponibles"
                            />
                        ) : (
                            pageData.map((row, rowIdx) => (
                                <tr key={rowIdx}>
                                    {columns.map((col, colIdx) => (
                                        <td key={colIdx} className="text-sm">
                                            {getFieldValue(row, col.field)}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </AppTableCard>
        </div>
    );
};

export default BuroTableTK;
